import { IMDSToggleButtonProps, MDSToggleButtonSlotName } from "./toggle-button.types";
import { StyledToggleButton } from "./toggle-button.style";
import { getSlot, getUnslottedChildren } from "@/mds/utils/slots";

/**
 * MDSToggleButton component with support for multiple variants.
 *
 * Supports two variants:
 * - Default: Standard toggle button with border
 * - Pill: Rounded pill-shaped button with background color styling
 *
 * The pill variant supports optional left and right icon slots:
 * ```tsx
 * <MDSToggleButton variant="pill">
 *   <MDSToggleButtonIcon kind={MdsIconKind.Plus} slot="leftIcon" />
 *   Button Text
 *   <MDSToggleButtonIcon kind={MdsIconKind.Clear} slot="rightIcon" />
 * </MDSToggleButton>
 * ```
 */
export function MDSToggleButton(props: IMDSToggleButtonProps) {
  const { children, ariaLabel, variant, ...rest } = props;

  const unslottedChildren = getUnslottedChildren(children);
  const leftIcon = getSlot(children, MDSToggleButtonSlotName.LeftIcon);
  const rightIcon = getSlot(children, MDSToggleButtonSlotName.RightIcon);

  return (
    <StyledToggleButton {...rest} aria-label={ariaLabel} variant={variant}>
      {leftIcon}
      {unslottedChildren}
      {rightIcon}
    </StyledToggleButton>
  );
}
